import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
const SuccessComponent = props => {
  const {
    sucessTitle,
    sucessSubtitle,
    humanImage,
    bankOfAmericaImage,
    mellonImage,
    nyseImage,
    mufgImage,
    guthyImage,
    MRVImage,
  } = props;
  return (
    <div className="full">
      <div className="row">
        <div className="col-12">
          <div className="sucess-section">
            <div className="sucess-section_image"></div>
            <div className="sucess-section_text">
              <h2 className="sucess-section_text-title">{sucessTitle}</h2>
              <div>
                <p className="sucess-section_text-description">
                  {sucessSubtitle} ​
                </p>
              </div>
              <div className="sucess-section_swiper">
                <div className="slider">
                  <div className="slide-track">
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={humanImage}
                        alt={''}
                        className="sucess-section_swiper-image"
                      />
                    </div>
                    <div className="slide">
                      {' '}
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={bankOfAmericaImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={mellonImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={mufgImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={nyseImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={guthyImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      {' '}
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={MRVImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={humanImage}
                        alt={''}
                        className="sucess-section_swiper-image"
                      />
                    </div>
                    <div className="slide">
                      {' '}
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={bankOfAmericaImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={mellonImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={mufgImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={nyseImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={guthyImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                    <div className="slide">
                      {' '}
                      <GatsbyImage
                        imgStyle={{ width: '100%' }}
                        image={MRVImage}
                        alt={''}
                        className="sucess-section_swiper-image "
                      />
                    </div>
                  </div>
                  <div className="sucess-section_swiper-mobile">
                    <Swiper
                      spaceBetween={0}
                      slidesPerView={'3'}
                      speed={1500}
                      modules={[Autoplay]}
                      centeredSlides
                      autoplay={{
                        delay: 1,
                        disableOnInteraction: true,
                      }}
                      breakpoints={{
                        768: {
                          slidesPerView: 6,
                        },
                      }}
                      loop
                    >
                      <div className="swiper-container">
                        <div className="swiper-wrapper">
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={humanImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={bankOfAmericaImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={mellonImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={mufgImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={nyseImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={guthyImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <GatsbyImage
                              imgStyle={{ width: '100%' }}
                              image={MRVImage}
                              alt={''}
                             className="sucess-section_swiper-image"
                            />
                          </SwiperSlide>
                        </div>
                      </div>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SuccessComponent;
